import script from "./PerformanceAnalyticsOrganism.vue?vue&type=script&setup=true&lang=ts"
export * from "./PerformanceAnalyticsOrganism.vue?vue&type=script&setup=true&lang=ts"

import "./style.css?vue&type=style&index=0&id=13bb8b25&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13bb8b25"]])

export default __exports__